import { useEffect, useState } from "react";
import VideoCaptureUtilService from "../services/viedoCaptureUtil.service";
import { VideoCaptureUseCase } from "../../application/use-cases/videoCapture.usecase";
import Image from "../components/atoms/image";
import Button from "../components/atoms/button";
import Top from "../components/templates/top";
import Link from "../components/atoms/link";
import { useNavigate } from "react-router-dom";
import ic_selfie_blue from "../assets/icons/ic_selfie_blue.svg";
import listText from "../utils/dictionaries/dictionary-video-capture-condition";
import redCircleExclamationSharpSolid from "../assets/icons/red-circle-exclamation-sharp-solid.svg";
import circleInfoSharpRegular from "../assets/icons/circle-info-sharp-regular.svg";
import TitleAndImage from "../components/molecules/title-and-image";
import blue_phone from "../assets/icons/blue_phone.svg";
import { useRedux } from "../hooks/useRedux";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query'

const queryClient = new QueryClient()

export default function VideoCaptureCondition() {
  return (
    <QueryClientProvider client={queryClient}>
      <Video />
    </QueryClientProvider>
  )
}

function Video() {
  const [somethingWentWrong, setSomethingWentWrong] = useState(false);
  const [videoRecordingData, setVideoRecordingData] = useState({uuid:"",token:"",token_encoded:"",public_url:""})

  const { data: { clientPersist: { uuid } } } = useRedux();
  const navigate = useNavigate();
  const caseVideo = new VideoCaptureUtilService();
  const useCaseVideo = new VideoCaptureUseCase(caseVideo);

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/IdentityValidation",
        step: "/IdentityValidation",
        data: {}, // Agregar data del formulario
      },
    });
  };

  const getVideoRecording = async () => {
    const responseVideoRecording = await useCaseVideo.postVideoRecording(uuid);
    setVideoRecordingData({
      uuid:responseVideoRecording.data.uuid,
      token:responseVideoRecording.data.token,
      token_encoded:responseVideoRecording.data.token_encoded,
      public_url: responseVideoRecording.data.public_url
    });
    setTimeout(() => {
      window.open(responseVideoRecording.data.public_url);
    }, 2000);
  };

  useEffect(() => {
    return () => {
      getVideoRecording();
    };
  }, []);

  const { isLoading, error, data: dataVideoWf } = useQuery({
    queryKey: ['videoWorkflows'],
    queryFn: async () => {
      const dataVW = await  useCaseVideo.getVideoRecordingWorkflows(uuid, videoRecordingData.uuid);
      return dataVW;
  },
    refetchInterval: 3000
  })

  useEffect(()=>{
    if(dataVideoWf?.data){
      console.log(dataVideoWf?.data.result.status)
      if(dataVideoWf?.data.result.status == "success"){
        navigate("/CustomizableViewOk")
      } else if (dataVideoWf?.data.result.status == "error") {
        setSomethingWentWrong(true);
      }
    }//success
  }, [dataVideoWf])
  
  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.text_1.mainText}
          subTitle={listText.text_2.mainText}
          displayProgressBar={""}
          displayLeftImageTitle={"d-none"}
          classTitleImage={"ms-2"}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"90%"}
          comeFrom={"/ErrorVideoCapture"}
          onClickGoBackIcon={() => navigate("/")}
        />
        <div className="p-3">
          <div className="text-center mb-4_3 mt-4">
            <Image
              srcImage={ic_selfie_blue}
              className={"ic_selfie_blue"}
              alt={""}
              dataBsDismiss={""}
              styleImg={undefined}
              onClick={undefined}
            ></Image>
          </div>
          <div style={{ backgroundColor: "#F7F7F7" }}>
            <TitleAndImage
              srcImage={somethingWentWrong? redCircleExclamationSharpSolid : circleInfoSharpRegular}
              titleText={somethingWentWrong? listText.text_3.mainText : listText.text_8.mainText}
              displayLeftImageTitle={""}
              classTitle={"ms-2"}
              styleTitle={{ fontSize: 16, fontWeight: 400 }}
              onClickTitleImgeDiv={undefined}
              divClass={"mb-2"}
            />
          </div>
        </div>
      </div>
      <div className="footer--pin">
        <a
          target="_blank"
          rel=""
          href="tel:8008003224"
          className={"d-grid gap-2 w-100 place-content-center align-self-center rounded-3 pt-3 border border-3"}
          style={{color: "#004A94", fontSize: 16, fontWeight: 600, borderColor: "#004A94"}}
          >
            <p><img src={"" + blue_phone} /> {listText.text_5.mainText}</p>
        </a>
        <Button
          text={listText.text_6.mainText}
          divClassName={"d-grid gap-2 mt-2"}
          buttonClassName={`w-100 place-content-center align-self-center button-enabled`}
          spinner={false}
          onClick={() => window.location.reload()}
          disabled={false}
          dataBsDismiss={undefined}
        />

        <div className="text-center mt-3">
          <Link
            text={listText.text_7.mainText}
            url={null}
            styleLink={{
              color: "#5A6172",
              lineHeight: "16px",
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={() => followLaterAction()}
            className={""}
          />
        </div>
      </div>
    </>
  )
}